<template>
    <div ref="root" class="single-side row">

        <div class="description-wrapper order-last order-lg-first col-12 col-lg-4 d-flex flex-column align-items-start justify-content-between">

            <div class="px-0 w-100"></div>

            <div class="mt-4 mt-lg-0">
                <a class="text-decoration-none" :href="button?.url"><h1 class="title mb-3 mb-lg-5">{{header}}</h1></a>
                <div class="d-inline-block mb-3 mb-lg-5">{{slogan}}</div>
                <div>
                    <a :href="button?.url" target="_blank" class="d-inline-block btn-ccc btn-ccc-slider">{{button?.title}}</a>
                </div>
            </div>

            <div class="progress-strips-wrapper row" style="max-width: 90%;">
                <div
                    v-if="numOfAllSlides > 1"
                    v-for="num in numOfAllSlides"
                    :key="num"
                    :class="[
                        'col progress-strip',
                        {'is-done': num < currentSlideIndex + 1},
                        {'is-animating': num === currentSlideIndex + 1}
                    ]"
                    @click.prevent="$emit('changeSlide', num - 1)"
                >
                    <div class="progress-background">
                        <span class="progress-fill"></span>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-12 col-lg-8 p-lg-0">

            <a
                :class="[
                    'background-wrapper',
                    {'is-loaded':isBackgroundImgLoaded}
                ]"
                :href="button?.url"
            >
                <img
                        class="background-placeholder"
                        :src="img?.lazy"
                        alt=""
                >
                <img
                        :class="[
                    'background-img'
                ]"
                        alt=""
                        :src="img?.src"
                        :srcset="img?.srcset"
                        @load="onBackgroundImgLoaded"
                >

                <div
                    v-if="numOfAllSlides > 1"
                    class="nav-button left d-block d-lg-none"
                    @click.prevent="$emit('prevSlide')"
                >←</div>
                <div
                    v-if="numOfAllSlides > 1"
                    class="nav-button right d-block d-lg-none"
                    @click.prevent="$emit('nextSlide')"
                >→</div>

            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "SingleSlide",
    emits: ['changeSlide', 'prevSlide', 'nextSlide'],
    props: {
        header: String,
        slogan: String,
        button: Object,
        img: Object,
        numOfAllSlides: Number,
        currentSlideIndex: Number
    },
    data(){
        return {
            isBackgroundImgLoaded: false,
            touchStartX: null,
            touchStartY: null
        }
    },
    mounted(){

        this.$refs.root.ontouchstart = (e) => {
            this.touchStartX = e.changedTouches[0].screenX;
            this.touchStartY = e.changedTouches[0].screenY;
        }

        this.$refs.root.ontouchend = (e) => {

            const verticalMaxDistance = 100;
            const horizontalMinDistance = 100;

            const horizontalDistance    = Math.sqrt(Math.pow(this.touchStartX - e.changedTouches[0].screenX, 2))
            const verticalDistance      = Math.sqrt(Math.pow(this.touchStartY - e.changedTouches[0].screenY, 2))

            if(verticalDistance > verticalMaxDistance) return null;
            if(horizontalDistance > horizontalMinDistance){

                if(this.touchStartX > e.changedTouches[0].screenX){
                    this.$emit('prevSlide');
                } else {
                    this.$emit('nextSlide');
                }

            }

        }

    },
    methods: {
        onBackgroundImgLoaded(){
            setTimeout(()=>{
                this.isBackgroundImgLoaded = true
            }, 1000)
        }
    }
}
</script>

<style lang="scss" scoped>

.nav-button {
    position: absolute;
    display: block;
    width: 32px;
    height: 32px;
    background: #FFFFFF;
    bottom: 15px;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    line-height: 32px;
    color: black;

    &.left {
        left: 0;
    }
    &.right {
        right: 0;
    }
}

.title {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: black;

    @media screen and (min-width: 1350px) {
        font-size: 40px;
        line-height: 60px;
    }

    @media screen and (min-width: 1024px) and (max-width: 1349px) {
        font-size: 30px;
        line-height: 48px;
    }

}

.description-wrapper {

}

.background-wrapper {

    display: block;
    position: relative;
    height: 340px;
    overflow: hidden;
    cursor: pointer;

    @media screen and (min-width: 768px){

        height: 500px;
        opacity: 0;

        @keyframes slider-background-anim {
            0% {
                opacity: 0;
                transform: translateX(50px);
            }
            100% {
                opacity: 1;
                transform: translateX(0);
            }
        }

        animation-name: slider-background-anim;
        animation-duration: 0.5s;
        animation-delay: 0.5s;
        animation-fill-mode: forwards;

    }

    &.is-loaded {

        .background-img {
            opacity: 1;
        }
        .background-placeholder {
            opacity: 0;
        }

    }

    .background-placeholder {
        position: absolute;
        z-index: 1;
        display: block;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: 500ms all;
        filter: blur(15px);
    }

    .background-img {
        position: absolute;
        z-index: 2;
        display: block;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: 500ms all;
        opacity: 0;
    }

}

.progress-strips-wrapper {

    margin: 0;
    padding: 0;
    width: 100%;
    max-width: 90%;

    .progress-strip {

        padding: 15px 0 0 0;
        margin: 0 15px 0 0;
        cursor: pointer;

        .progress-background {
            background: #EAEAEA;
        }

        .progress-fill {
            display: block;
            width: 0;
            height: 4px;
            background: #3d3d3d;
        }

        &.is-done {
            .progress-fill {
                width: 100%;
            }
        }
        &.is-animating {
            .progress-fill {

                @keyframes progress-fill-anim {
                    0% {width: 0;}
                    100% {width: 100%;}
                }

                animation: progress-fill-anim;
                animation-duration: 5s;
                animation-timing-function: linear;

            }
        }

    }

}

</style>